export default __webpack_public_path__ + "assets/7a854b70804add894113964546957d94.png";